/*
This file is for handle socket events.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date : 28/11/2017 11:14 AM
*/

/* global */
import VcxEventProperties from './vcxEventProperties'; // This package is for fetch global event nameProp
import io from '../lib/socket.io'; // This package is to use socket library functions
import Logger from './utils/Logger'; // This package is for manage console log.
import customEvents from './customEvents';
import EL from './EventLogger';
import customErrors from './customErrors';

import { EventDispatcher, Event } from './Events';
// This package is needed for managing events
const SocketEvent = (type, specInput) => {
  const that = Event({ type });
  that.args = specInput.args;
  return that; // This is a object of events handler
};

/*
 * Class Stream represents a local or a remote Stream in the Room. It will handle the WebRTC
 * stream and identify the stream and where it should be drawn.
 */
const Socket = (newIo) => {
  const that = EventDispatcher();
  const defaultCallback = () => { };
  const messageBuffer = []; // This is an array to store event message as a buffer.

  that.CONNECTED = Symbol('connected');
  that.RECONNECTING = Symbol('reconnecting');
  that.DISCONNECTED = Symbol('disconnected');

  const WEBSOCKET_NORMAL_CLOSURE = 1000; // This is a variable used to store socket closure status code in normal state
  // This can be modified and varry denpendending on webscket closure resons
  that.state = that.DISCONNECTED;
  that.IO = newIo === undefined ? io : newIo;

  let socket;

  const emit = (type, ...args) => { // Function that calls Events' emit function
    that.emit(SocketEvent(type, { args }));
  };

  const addToBuffer = (type, message, callback, error) => { // Function defination that store a message in buffer array
    messageBuffer.push([type, message, callback, error]);
  };

  const removeFromBuffer = (type, message, callback, error) => { // Function defination that removes a message from buffer array
    const index = messageBuffer.indexOf([type, message, callback, error]);
    if (index !== -1) { // Checking : If the message sent to remove is present in buffer array or not
      messageBuffer.splice(index, 1);
    }
  };

  const executeBuffer = () => {
    Logger.info('execute buffer');					// Function to send all message to connected socket stored in buffer
    if (that.state !== that.CONNECTED) {
      return;
    }
    messageBuffer.forEach((message) => {
      that.sendMessage(...message);
    });
  };

  const checkSSL = () => ((window.location.protocol == 'https:'));
  that.connect = (token, callback = defaultCallback, error = defaultCallback) => {
    const options = {
      reconnection: false,
      //  reconnectionAttempts: 3,
      secure: token.secure,
      forceNew: true,
      transports: ['websocket'],
      rejectUnauthorized: true,
    };
    const transport = checkSSL() ? 'wss://' : 'ws://';
    let host = token.host;
    if (token.gateway == undefined || token.gateway == null || token.gateway == '') {
      host = token.host;
    } else {
      host = token.gateway;
      options.query = `X-Forwarded-Host=${token.host}`;
    }
    Logger.info(`Connecting socket with option:- ${JSON.stringify(options)}`);
    Logger.info(`Connecting socket with host:- ${host}`);
    socket = that.IO.connect(transport + host, options);

    // Hack to know the exact reason of the WS closure (socket.io does not publish it)
    let closeCode = WEBSOCKET_NORMAL_CLOSURE;
    const socketOnCloseFunction = socket.io.engine.transport.ws.onclose;
    socket.io.engine.transport.ws.onclose = (closeEvent) => {
      Logger.warning('WebSocket closed, code:', closeEvent.code);
      closeCode = closeEvent.code;
      socketOnCloseFunction(closeEvent);
    };
    socket.io.engine.transport.ws.onerror = (errorEvent) => { };
    that.socket = socket;

    socket.on(VcxEventProperties.UserEvent.user_awaited, emit.bind(that, VcxEventProperties.UserEvent.user_awaited));
    socket.on(VcxEventProperties.UserEvent.user_joined, emit.bind(that, VcxEventProperties.UserEvent.user_joined));
    socket.on(VcxEventProperties.RoomEvent.room_connected, emit.bind(that, VcxEventProperties.RoomEvent.room_connected));
    socket.on(VcxEventProperties.RoomEvent.room_disconnected, emit.bind(that, VcxEventProperties.RoomEvent.room_disconnected));
    socket.on(VcxEventProperties.RoomEvent.new_active_talker, emit.bind(that, VcxEventProperties.RoomEvent.new_active_talker));
    socket.on(VcxEventProperties.SocketEvent.onAddStream, emit.bind(that, VcxEventProperties.SocketEvent.onAddStream));
    socket.on(VcxEventProperties.SocketEvent.signaling_message_peer, emit.bind(that, VcxEventProperties.SocketEvent.signaling_message_peer));
    socket.on(VcxEventProperties.SocketEvent.publish_me, emit.bind(that, VcxEventProperties.SocketEvent.publish_me));
    socket.on(VcxEventProperties.SocketEvent.unpublish_me, emit.bind(that, VcxEventProperties.SocketEvent.unpublish_me));
    socket.on(VcxEventProperties.SocketEvent.onBandwidthAlert, emit.bind(that, VcxEventProperties.SocketEvent.onBandwidthAlert));
    socket.on(VcxEventProperties.SocketEvent.onSelfBandwidthAlert, emit.bind(that, VcxEventProperties.SocketEvent.onSelfBandwidthAlert));
    socket.on(VcxEventProperties.SocketEvent.onRemoveTrack, emit.bind(that, VcxEventProperties.SocketEvent.onRemoveTrack));
    // We receive an event of new data in one of the streams
    socket.on(VcxEventProperties.SocketEvent.onDataStream, emit.bind(that, VcxEventProperties.SocketEvent.onDataStream));
    socket.on(VcxEventProperties.RoomEvent.room_awaited, emit.bind(that, VcxEventProperties.RoomEvent.room_awaited));
    socket.on(VcxEventProperties.RoomEvent.room_record_on, emit.bind(that, VcxEventProperties.RoomEvent.room_record_on));
    socket.on(VcxEventProperties.RoomEvent.room_record_off, emit.bind(that, VcxEventProperties.RoomEvent.room_record_off));
    socket.on(VcxEventProperties.RoomEvent.hard_mute_audio, emit.bind(that, VcxEventProperties.RoomEvent.hard_mute_audio));
    socket.on(VcxEventProperties.RoomEvent.hard_unmute_audio, emit.bind(that, VcxEventProperties.RoomEvent.hard_unmute_audio));
    socket.on(VcxEventProperties.RoomEvent.hard_mute_video, emit.bind(that, VcxEventProperties.RoomEvent.hard_mute_video));
    socket.on(VcxEventProperties.RoomEvent.hard_unmute_video, emit.bind(that, VcxEventProperties.RoomEvent.hard_unmute_video));
    socket.on(VcxEventProperties.RoomEvent.share_started, emit.bind(that, VcxEventProperties.RoomEvent.share_started));
    socket.on(VcxEventProperties.RoomEvent.share_stopped, emit.bind(that, VcxEventProperties.RoomEvent.share_stopped));

    socket.on(VcxEventProperties.RoomEvent.canvas_started, emit.bind(that, VcxEventProperties.RoomEvent.canvas_started));
    socket.on(VcxEventProperties.RoomEvent.canvas_stopped, emit.bind(that, VcxEventProperties.RoomEvent.canvas_stopped));
    socket.on(VcxEventProperties.RoomEvent.invite_breakout_room, emit.bind(that, VcxEventProperties.RoomEvent.invite_breakout_room));
    socket.on(VcxEventProperties.RoomEvent.user_joined_breakout_room, emit.bind(that, VcxEventProperties.RoomEvent.user_joined_breakout_room));
    socket.on(VcxEventProperties.RoomEvent.user_left_breakout_room, emit.bind(that, VcxEventProperties.RoomEvent.user_left_breakout_room));
    socket.on(VcxEventProperties.RoomEvent.breakout_room_destroyed, emit.bind(that, VcxEventProperties.RoomEvent.breakout_room_destroyed));
    //Dial State Events
    socket.on(VcxEventProperties.SocketEvent.dial_state_events, emit.bind(that, VcxEventProperties.SocketEvent.dial_state_events));

    socket.on(VcxEventProperties.UserEvent.user_audio_muted, emit.bind(that, VcxEventProperties.UserEvent.user_audio_muted));
    socket.on(VcxEventProperties.UserEvent.user_audio_unmuted, emit.bind(that, VcxEventProperties.UserEvent.user_audio_unmuted));
    socket.on(VcxEventProperties.UserEvent.user_video_muted, emit.bind(that, VcxEventProperties.UserEvent.user_video_muted));
    socket.on(VcxEventProperties.UserEvent.user_video_unmuted, emit.bind(that, VcxEventProperties.UserEvent.user_video_unmuted));

    socket.on(VcxEventProperties.SocketEvent.media_engine_connecting, emit.bind(that, VcxEventProperties.SocketEvent.media_engine_connecting));
    socket.on(VcxEventProperties.SocketEvent.onUpdateAttributeStream, emit.bind(that, VcxEventProperties.SocketEvent.onUpdateAttributeStream));
    socket.on(VcxEventProperties.SocketEvent.onRemoveStream, emit.bind(that, VcxEventProperties.SocketEvent.onRemoveStream));
    socket.on(VcxEventProperties.SocketEvent.user_connected, emit.bind(that, VcxEventProperties.SocketEvent.user_connected));
    socket.on(VcxEventProperties.SocketEvent.user_disconnected, emit.bind(that, VcxEventProperties.SocketEvent.user_disconnected));
    socket.on(VcxEventProperties.SocketEvent.user_subscribed, emit.bind(that, VcxEventProperties.SocketEvent.user_subscribed));
    socket.on(VcxEventProperties.SocketEvent.floor_requested, emit.bind(that, VcxEventProperties.SocketEvent.floor_requested));
    socket.on(VcxEventProperties.SocketEvent.floor_granted, emit.bind(that, VcxEventProperties.SocketEvent.floor_granted));
    socket.on(VcxEventProperties.SocketEvent.floor_not_granted, emit.bind(that, VcxEventProperties.SocketEvent.floor_not_granted));
    socket.on(VcxEventProperties.SocketEvent.floor_released, emit.bind(that, VcxEventProperties.SocketEvent.floor_released));
    socket.on(VcxEventProperties.SocketEvent.hard_mute, emit.bind(that, VcxEventProperties.SocketEvent.hard_mute));
    socket.on(VcxEventProperties.SocketEvent.hard_mute_room, emit.bind(that, VcxEventProperties.SocketEvent.hard_mute_room));
    socket.on(VcxEventProperties.SocketEvent.hard_unmute_room, emit.bind(that, VcxEventProperties.SocketEvent.hard_unmute_room));
    socket.on(VcxEventProperties.SocketEvent.switched_room, emit.bind(that, VcxEventProperties.SocketEvent.switched_room));
    socket.on(VcxEventProperties.SocketEvent.data_stream_room, emit.bind(that, VcxEventProperties.SocketEvent.data_stream_room));
    socket.on(VcxEventProperties.RoomEvent.user_role_changed, emit.bind(that, VcxEventProperties.RoomEvent.user_role_changed));
    // manu stats
    socket.on(VcxEventProperties.SocketEvent.onStatSubscription, emit.bind(that, VcxEventProperties.SocketEvent.onStatSubscription));
    socket.on(VcxEventProperties.SocketEvent.onStreamingNotification, emit.bind(that, VcxEventProperties.SocketEvent.onStreamingNotification));
    socket.on(VcxEventProperties.SocketEvent.onLiveRecordingNotification, emit.bind(that, VcxEventProperties.SocketEvent.onLiveRecordingNotification));

    socket.on(VcxEventProperties.RoomEvent.switch_codec, emit.bind(that, VcxEventProperties.RoomEvent.switch_codec));
    socket.on(VcxEventProperties.RoomEvent.generic_events, emit.bind(that, VcxEventProperties.RoomEvent.generic_events));
    socket.on(VcxEventProperties.SocketEvent.room_management_events, emit.bind(that, VcxEventProperties.SocketEvent.room_management_events));
    socket.on(VcxEventProperties.SocketEvent.floor_management_events, emit.bind(that, VcxEventProperties.SocketEvent.floor_management_events));


    socket.on(VcxEventProperties.SocketEvent.disconnect, (reason) => {
      Logger.debug(VcxEventProperties.SocketEvent.disconnect, that.id, reason);
      if (closeCode !== WEBSOCKET_NORMAL_CLOSURE) {
        socket.close();
        emit(VcxEventProperties.SocketEvent.disconnect, reason);
        return;
        /*  emit( VcxEventProperties.SocketEvent.disconnect, reason );
          that.state = that.RECONNECTING;
          return;  */
      }
      socket.close();
      emit(VcxEventProperties.SocketEvent.disconnect, reason);
    });

    /*  From here starts hadling different socket events which are called on socket   */
    socket.on(VcxEventProperties.SocketEvent.connect_timeout, (err) => {
      Logger.warning(`${VcxEventProperties.SocketEvent.connect_timeout}, id:`, that.id, ', error:', err.message);
      socket.close();
      emit(VcxEventProperties.SocketEvent.disconnect, err.message);
    });

    socket.on(VcxEventProperties.SocketEvent.connection_failed, () => {
      Logger.error(`${VcxEventProperties.SocketEvent.connection_failed}, id:`, that.id);
      emit(VcxEventProperties.SocketEvent.connection_failed, { streamId: that.id });
    });

    socket.on(VcxEventProperties.SocketEvent.connect_error, (err) => {
      Logger.warning(`${VcxEventProperties.SocketEvent.connect_error}, id:`, that.id, ', error:', err.message);
    });

    socket.on(VcxEventProperties.SocketEvent.error, (err) => {
      Logger.warning(`${VcxEventProperties.SocketEvent.error}, id:`, that.id, ', error:', err.message);
      emit(VcxEventProperties.SocketEvent.error);
    });

    socket.on(VcxEventProperties.SocketEvent.reconnecting, (attemptNumber) => {
      Logger.debug(`${VcxEventProperties.SocketEvent.reconnecting}, id:`, that.id, ', attempt:', attemptNumber);
    });

    socket.on(VcxEventProperties.SocketEvent.reconnect, (attemptNumber) => {
      Logger.debug(`${VcxEventProperties.SocketEvent.reconnected}, id:`, that.id, ', attempt:', attemptNumber);
      that.state = that.CONNECTED;
      socket.emit(VcxEventProperties.SocketEvent.reconnected, that.id);
      EL.info('socket-event', customEvents.event_reconnect_socket_success, { error: {} });
      executeBuffer();
    });

    socket.on(VcxEventProperties.SocketEvent.reconnect_attempt, (attemptNumber) => {
      Logger.debug(`${VcxEventProperties.SocketEvent.reconnect_attempt}, id:`, that.id, ', attempt:', attemptNumber);
    });

    socket.on(VcxEventProperties.SocketEvent.reconnect_failed, () => {
      Logger.warning(`${VcxEventProperties.SocketEvent.reconnect_failed}, id:`, that.id);
      that.state = that.DISCONNECTED;
      emit(VcxEventProperties.SocketEvent.disconnect, VcxEventProperties.SocketEvent.reconnect_failed);
      EL.error('socket-event', customEvents.event_reconnect_socket_failed, { error: {} });
    });

    socket.on(VcxEventProperties.SocketEvent.reconnect_error, (err) => {
      Logger.debug(`${VcxEventProperties.SocketEvent.reconnect_error}, id:`, that.id, ', error:', err.message);
    });

    // First message with the token to the connected socket
    that.sendMessage('token', token, (response) => {
      that.state = that.CONNECTED;
      that.id = response.clientId;
      callback(response);
    }, error);
  };

  that.disconnect = () => {
    Logger.debug('socket js disconnect the socket');
    that.state = that.DISCONNECTED;
    socket.disconnect();
  };

  // Function to send a message to the server socket using socket.io
  that.sendMessage = (type, msg, callback = defaultCallback, error = defaultCallback) => {
    if (that.state === that.DISCONNECTED && type !== 'token') {
      Logger.error('Trying to send a message over a disconnected Socket');
      callback(customErrors.error_1163);
      return;
    }
    if (that.state === that.RECONNECTING) {
      Logger.debug('sendmessage socket state is reconnecting');
      addToBuffer(type, msg, callback, error);
      callback(customErrors.error_1164);
      return;
    }

    if (msg) {
      socket.emit(type, msg, (respType, resp) => {
        if (respType === 'success') {
          callback(resp);
        } else if (respType === 'error') {
          EL.error('socket-event', customEvents.event_send_message_failed, { type, respType, resp });
          error(resp);
        } else {
          callback(respType, resp);
        }
      });
    } else {
      callback(customErrors.error_1155);
    }
  };

  // It sends a SDP message to the server using socket.io
  that.sendSDP = (type, options, sdp, callback = defaultCallback) => {
    if (that.state === that.DISCONNECTED) {
      Logger.error('Trying to send a message over a disconnected Socket');
      EL.error('socket-event', customEvents.event_send_message_failed, { error: 'Trying to send a message over a disconnected Socket' });
      return;
    }
    socket.emit(type, options, sdp, (response, respCallback) => {
      callback(response, respCallback);
    });
  };

  that.emitEvent = (type, options, callback = defaultCallback) => {
    if (that.state === that.DISCONNECTED) {
      Logger.error('Trying to send a message over a disconnected Socket');
      EL.error('socket-event', customEvents.event_send_message_failed, { error: 'Trying to send a message over a disconnected Socket' });
      return;
    }
    socket.emit(type, options, (response, respCallback) => {
      callback(response, respCallback);
    });
  };

  that.sendEvent = (type, callback = defaultCallback) => {
    if (that.state === that.DISCONNECTED) {
      Logger.error('Trying to send a message over a disconnected Socket');
      EL.error('socket-event', customEvents.event_send_message_failed, { error: 'Trying to send a message over a disconnected Socket' });
      return;
    }
    socket.emit(type, (response) => {
      callback(response);
    });
  };

  that.sendParamEvent = (type, clientId, callback = defaultCallback) => {
    if (that.state === that.DISCONNECTED) {
      Logger.error('Trying to send a message over a disconnected Socket');
      EL.error('socket-event', customEvents.event_send_message_failed, { error: 'Trying to send a message over a disconnected Socket' });
      return;
    }
    socket.emit(type, clientId, (response) => {
      callback(response);
    });
  };
  return that;
};
export { SocketEvent, Socket };



//////////////////
// WEBPACK FOOTER
// ./src/Socket.js
// module id = 177
// module chunks = 0